module.exports = __webpack_public_path__ + "img/unona.1330be89.png";